import {tokens} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import Card from '@/components/card'
import type {Props as RichTextProps} from '@helios/shared/components/rich-text'
import {Layout, Section} from '@helios/shared/styles/grid'
import {Text} from '@helios/shared/styles/typography'
import type ImageSource from '@helios/shared/types/image'
import mq from '@helios/shared/utils/media-query'

import {MOBILE_BREAKPOINT} from '../shared'

interface Item {
    image?: ImageSource
    title: string
    body?: RichTextProps['content']
}

interface Props {
    title?: string
    items: Item[]
}

export const BaseBenefits = ({title, items}: Props) => {
    return (
        <Section>
            <Text variant="title-base" as="h2">
                {title}
            </Text>
            <StyledLayout variant="three-equal">
                {items.map((item) => (
                    <StyledCard
                        key={item.title}
                        image={item.image}
                        title={item.title}
                        titleAs="h3"
                        body={item.body}
                    />
                ))}
            </StyledLayout>
        </Section>
    )
}

const StyledLayout = styled(Layout)`
    margin-top: ${tokens.spacing20};

    ${mq.min(MOBILE_BREAKPOINT)} {
        margin-top: ${tokens.spacing40};
    }
`

export const StyledCard = styled(Card)`
    ${mq.max(MOBILE_BREAKPOINT)} {
        padding: 0;
    }

    ul {
        display: block;
        padding-left: ${tokens.spacing20};
    }
`

export default BaseBenefits
